import { BaseGamePadDrawer } from './BaseGamePadDrawer';
import { mobileGamePadResources } from '../../../core/mobileResources';
import { mobileGameRssNames } from '../../../core/mobileResourceNames';
import { gameMobileConfig } from '../../../core/configs';
import { gamePadLocaleState } from '../state';
import { getTranslation, translationKeys } from '../../../core/translation/translation';
import {
  AUTO_SPIN_COUNTS,
  AUTO_SPIN_INDEX,
  BONUS_RESPONSE_TOTAL_AMOUNT,
  GAME_PAD_SPIN_ACTIVE,
  SPIN_AMOUNT,
  SPIN_AMOUNT_ACTIVE,
  AUTO_SPIN_COUNT,
  SPIN_COUNT_CHANGE_STATE,
  BET_AMOUNT_CHANGE_STATE,
  AUTO_SPIN_BUTTON_STATE,
} from '../../../stateManagment/gameState';
import { FONT_LATO_NAME } from '../../../core/constats';
import { delay } from '../../../core/helpers/delay';
import { spinButtonHelper } from '../../../services/helperService/SpinButtonHelper';
import { animationDrawer } from '../../../core/AnimationDrawer';
import { amountFormatter } from '../../../core/helpers/amountFormatter';
import { soundService } from '../../../services/helperService/PixiSoundService';
import { partnerService } from '../../../services/helperService/PartnerService';
import { debounce } from '../../../core/helpers/debounce';
import { autoSpinHelper } from '../../../services/helperService/AutoSpinHelper';
import { bigWinService } from '../../../services/helperService/BigWinService';
import { popupHelper } from '../../../services/helperService/PopupHelper';
import { bonusPreBonusSharedDrawer } from '../../bonusPreBonusShared/BonusPreBonusSharedDrawer';
import {gameDrawer} from "../../../game/GameDrawer";

class GamePadMobileDrawer extends BaseGamePadDrawer {
  constructor() {
    super();
    this.loader = this.createLoader();
    this.container = null;
    this.config = {
      position: gameMobileConfig.gamePadPosition,
      helperButtonSize: { w: 110, h: 110 },
      autoPlaySpinPosition: { x: gameMobileConfig.config.width / 2 },
      betButtonPosition: { x: 153, y: 35 },
      betConPosition: { x: -70, y: -150 },
    };

    gamePadLocaleState.autoSpinButtonActive.subscribe(bool => {
      if (gamePadLocaleState.betButtonActive.getValue() && bool) {
        gamePadLocaleState.betButtonActive.next(false);
      }
    });
    gamePadLocaleState.betButtonActive.subscribe(bool => {
      if (gamePadLocaleState.autoSpinButtonActive.getValue() && bool) {
        gamePadLocaleState.autoSpinButtonActive.next(false);
      }
    });
  }

  resetOpenedState() {
    gamePadLocaleState.betButtonActive.next(false);
    gamePadLocaleState.autoSpinButtonActive.next(false);
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(mobileGamePadResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  setupContainerPosition() {
    this.setPosition(this.container, gameMobileConfig.gamePadPosition);
  }

  setSpinButton({ onClick = () => null, checkActive } = {}) {
    const spinButton = this.getSpinButton({
      name: mobileGameRssNames.spinIcon, scale: 1.2, w: 180, h: 180, onClick: (arg) => {
        soundService.playSpin();
        if (checkActive()) {
          onClick(arg);
          autoSpinHelper.autoSpinFlag = gamePadLocaleState.autoSpinButtonActive.getValue();
          this.resetOpenedState();
        }
      },
    });
    this.setPosition(spinButton, { x: gameMobileConfig.config.width / 2, y: spinButton.height / 2 });
    this.addSubscriber(autoSpinHelper.subscribeAutoSpinState((isAutoSpin) => {
      spinButton.visible = !isAutoSpin;
    }, true));
    this.container.addChild(spinButton);
  }

  setAutoSpinButton({ onClick = () => null, checkActive = () => true } = {}) {
    const button = this.getAutoSpinButton({
      name: mobileGameRssNames.autoSpinIcon,
      infinity: mobileGameRssNames.infinityIconDark,
      countObserver: AUTO_SPIN_COUNT,
      scale: 1.2,
      w: 180,
      h: 180,
      onClick: (arg) => {
        soundService.playSpin();
        if (checkActive()) {
          onClick(arg);
          this.resetOpenedState();
        }
      },
    });
    this.addSubscriber(popupHelper.subscribeBuyBonusPopup((isOpen, { prev }) => {
      if (isOpen && autoSpinHelper.isAutoSpin) {
        autoSpinHelper.pause();
      }
      if (!isOpen && autoSpinHelper.isAutoSpin && autoSpinHelper.spinCount) {
        autoSpinHelper.resume();
        autoSpinHelper.cancelDelay();
        autoSpinHelper.setDelay(delay(() => {
          this._autoSpinClick();
        }, 1000));
      }
    }));

    this.setPosition(button, { x: gameMobileConfig.config.width / 2, y: button.height / 2 });
    this.addSubscriber(autoSpinHelper.subscribeAutoSpinState((isAutoSpin) => {
      button.visible = isAutoSpin;
    }, true));
    this.container.addChild(button);
  }

  setBetAmountValue() {
    const title = new this.PIXI.Text(`${getTranslation(translationKeys.BET)}`, {
      align: 'center', fill: 0xFFFFFF, fontSize: 16, fontFamily: FONT_LATO_NAME,
    });
    title.anchor.set(.5);

    const value = new this.PIXI.Text(`${getTranslation(translationKeys.BET)}`, {
      align: 'center', fill: 0xFFFFFF, fontSize: 24.5, fontFamily: FONT_LATO_NAME, fontWeight: 900,
    });
    value.anchor.set(.5);

    this.setPosition(title, { x: gameMobileConfig.config.width / 2, y: 200 });
    this.setPosition(value, { x: gameMobileConfig.config.width / 2, y: 220 });

    this.addSubscriber(SPIN_AMOUNT_ACTIVE.subscribe(index => {
      value.text = `${SPIN_AMOUNT.getValue()[index] || 0} ${partnerService.displayCurrency}`;
    }, true));
    this.container.addChild(title, value);
  }

  setAutoPlayButton() {
    const infinityIcon = this.createSprite(this.resources[mobileGameRssNames.infinityIcon]);
    infinityIcon.anchor.set(.5);
    infinityIcon.scale.set(1);
    const { container, controllerContainer } = super.getHelperButton({
      icon: mobileGameRssNames.autoplayIcon,
      activeBorderIcon: mobileGameRssNames.buttonBorderActive,
      notActiveBorderIcon: mobileGameRssNames.buttonBorderNonActive,
      observer: gamePadLocaleState.autoSpinButtonActive,
      sizes: this.config.helperButtonSize,
      title: getTranslation(translationKeys.PLAY),
      titleObserver: AUTO_SPIN_BUTTON_STATE,
      checkButtonActive: () => SPIN_COUNT_CHANGE_STATE.getValue(),
      onToggle: val => {
        if (AUTO_SPIN_BUTTON_STATE.getValue() && val) {
          console.log('vvvvvvvvvvv');
          this.handleAutoSpinClick();
        }
      },
    });
    this.setPosition(container, {
      x: gameMobileConfig.config.width / 2 + container.width, y: container.height / 2,
    });
    console.log(111111)
    const { content, valueText } = this._getAutoSpinController();
    console.log( content, valueText , " content, valueText")
    super.setupTextUpdate({
      textTexture: valueText,
      observer: AUTO_SPIN_COUNTS,
      indexObserver: AUTO_SPIN_INDEX,
      renderOption: (value, texture) => {
        if (value === Infinity) {
          if (texture.parent.children.length > 1) {
            texture.parent.children[1].alpha = 1;
          } else {
            texture.parent.addChild(infinityIcon);
          }
          return '';
        }
        if (texture.parent.children.length > 1) {
          texture.parent.children[1].alpha = 0;
        }
        return value;
      },
    });
    this.setPosition(content, {
      x: -content.width / 2, y: -content.height - 70,
    });
    super.setupToggle({ root: controllerContainer, content, observer: gamePadLocaleState.autoSpinButtonActive });
    this.container.addChild(container);
  }

  setBetButton() {
    const { container, controllerContainer } = super.getHelperButton({
      icon: mobileGameRssNames.betAmountIcon,
      activeBorderIcon: mobileGameRssNames.buttonBorderActive,
      notActiveBorderIcon: mobileGameRssNames.buttonBorderNonActive,
      observer: gamePadLocaleState.betButtonActive,
      sizes: this.config.helperButtonSize,
      checkButtonActive: () => BET_AMOUNT_CHANGE_STATE.getValue(),
    });
    this.setPosition(container, {
      x: gameMobileConfig.config.width / 2 - container.width, y: container.height / 2,
    });
    const { content, valueText } = this._getBetAmountController();


    this.setPosition(content, {
      x: -content.width / 2, y: -content.height - 70,
    });

    super.setupToggle({ root: controllerContainer, content, observer: gamePadLocaleState.betButtonActive });
    super.setupTextUpdate({
      textTexture: valueText, observer: SPIN_AMOUNT, indexObserver: SPIN_AMOUNT_ACTIVE,
    });
    container.addChild(container);
    this.container.addChild(container);
  }

  _getBetAmountController() {
    const { content, valueText, prev, next } = super.getGamePadController({
      nextIcon: mobileGameRssNames.betAmountPlus,
      prevIcon: mobileGameRssNames.betAmountMinus,
      wallpaperIcon: mobileGameRssNames.mobileController,
      title: getTranslation(translationKeys.BET),
      sizes: {
        width: 254, buttonSize: 64,
      },
      events: {
        handleNext: () => {
          soundService.playBetAmountChange();
          super.getNextButtonClick({ observer: SPIN_AMOUNT, indexObserver: SPIN_AMOUNT_ACTIVE });
        }, handlePrev: () => {
          soundService.playBetAmountChange();
          super.getPrevButtonClick({ observer: SPIN_AMOUNT, indexObserver: SPIN_AMOUNT_ACTIVE });
        },
      },
    });
    super.setupButtonActiveInActiveCase({
      prev, next, observer: SPIN_AMOUNT, indexObserver: SPIN_AMOUNT_ACTIVE,
    });
    return { content, valueText };
  }

  _getAutoSpinController() {
    const iii = getTranslation(translationKeys.AUTOSPIN)
    console.log(iii, "iii")
    const { content, valueText, next, prev } = super.getGamePadController({
      nextIcon: mobileGameRssNames.rightArrowIcon,
      prevIcon: mobileGameRssNames.leftArrowIcon,
      wallpaperIcon: mobileGameRssNames.mobileController,
      title: iii,
      sizes: {
        width: 254, buttonSize: 30,
      },
      events: {
        handleNext: () => {
          soundService.playSpinCountChange();
          super.getNextButtonClick({ observer: AUTO_SPIN_COUNTS, indexObserver: AUTO_SPIN_INDEX });
        }, handlePrev: () => {
          soundService.playSpinCountChange();
          super.getPrevButtonClick({ observer: AUTO_SPIN_COUNTS, indexObserver: AUTO_SPIN_INDEX });
        },
      },
      drawCircle: true,
    });
    super.setupButtonActiveInActiveCase({
      prev, next, observer: AUTO_SPIN_COUNTS, indexObserver: AUTO_SPIN_INDEX,
    });
    this.setPosition(content, this.config.betConPosition);
    return { content, valueText };
  }

  /** bonus Scene start*/
  setBonusPressToStart({ onClick }) {
    const textContainer = bonusPreBonusSharedDrawer.getTextContainer();
    const buttonContainer = bonusPreBonusSharedDrawer.getButtonContainer();
    const title = new this.PIXI.Text(`${getTranslation(translationKeys.pressToStart)}`, {
      fill: [0xfefefd, 0x9b7853],
      fontFamily: FONT_LATO_NAME,
      stroke: '#dec195',
      strokeThickness: 1,
      fontSize: 45,
      align: 'center',
    });

    const style = {
      fill: [0xfefefd, 0x9b7853],
      fontFamily: FONT_LATO_NAME,
      stroke: '#dec195',
      strokeThickness: 1,
      fontSize: 45,
      align: 'center',
    };

    const totalWinAmount = new this.PIXI.Text('', { ...style });
    this.setupButtonMode(title);
    this.registerClick(title, () => {
      animationDrawer.click(title);
      soundService.playSpin();
      if (spinButtonHelper.active) {
        onClick();
      }
    });
    title.anchor.set(.5);
    totalWinAmount.anchor.set(.5);
    totalWinAmount.alpha = 0;
    textContainer.alpha = 0;
    this.addSubscriber(BONUS_RESPONSE_TOTAL_AMOUNT.subscribe((value) => {
      const amount = value || 0;
      animationDrawer.blinking(totalWinAmount, .5, [1.1, .9, 1]);
      const text = `Win: ${amountFormatter.format(amount)} ${partnerService.displayCurrency}`;
      if (text.length > 19) {
        totalWinAmount.style = {
          ...style, fontSize: 40,
        };
      } else {
        totalWinAmount.style = {
          ...style, fontSize: 45,
        };
      }
      totalWinAmount.text = text;

    }, true));

    this.addSubscriber(GAME_PAD_SPIN_ACTIVE.subscribe((active) => {
      if (!active) {
        totalWinAmount.alpha = 1;
        textContainer.alpha = 1;
        buttonContainer.alpha = 0;
        title.alpha = 0;
      }
    }));
    this.setPosition(textContainer, { x: gameMobileConfig.config.width / 2, y: 50 });
    textContainer.addChild(totalWinAmount);
    this.container.addChild(textContainer);
  }

  /** bonus Scene end*/

  addBonusPressToStartLayer({ root }) {
    const rect = this.createGraphics()
      .beginFill(0x00000)
      .drawRect(0, 0, gameMobileConfig.config.width, gameMobileConfig.config.height)
      .endFill();
    rect.alpha = 0;
    this.setupButtonMode(rect);
    this.registerClick(rect, event => {
      event.stopPropagation();
      if (spinButtonHelper.active) {
        spinButtonHelper.disable();
        this._bonusSpinClick();
      }
    });
    root.addChild(rect);
  }

  async onLoad() {
    return this.loadResource();
  }

  async executeMainScene() {
    await this.loadResource();
    bigWinService.setContinueCallBack(() => {
      this._autoSpinClick();
    });
    bigWinService.setResumeCallBack(() => {
      autoSpinHelper.resume();
    });
    this.setupContainerPosition();
    this.setSpinButton({
      checkActive: () => spinButtonHelper.active, onClick: this.handleSpinButtonClick(),
    });
    this.setAutoSpinButton({
      onClick: this.handleAutoSpinButtonClick(),
    });
    this.setAutoPlayButton();
    this.setBetButton();
    this.setBetAmountValue();
  }

  async executePreBonusScene() {
    await this.loadResource();
    this.setupContainerPosition();
    // this.setSpinButton({
    //   checkActive: () => spinButtonHelper.active,
    //   onClick: debounce(() => preBonusContentDrawer.spin(), 300, true),
    // });
  }

  async executeBonusScene() {
    bonusPreBonusSharedDrawer.resetStyles();
    await bonusPreBonusSharedDrawer.loadResource();
    await this.loadResource();
    this.setupContainerPosition();
    bigWinService.setContinueCallBack(() => this._bonusSpinClick());
    bigWinService.setResumeCallBack(null);
    this.setBonusPressToStart({
      onClick: debounce(() => {
        this._bonusSpinClick();
      }, 300, true),
    });
  }
}

export const gamePadMobileDrawer = new GamePadMobileDrawer();
